import { ZERO } from '@/constants/common';
import Icon from 'ol/style/Icon';
import Style from 'ol/style/Style';
import { getPinSize, PinIcon } from '@/constants/canvas';
import { getCanvasIcon } from '../getCanvasIcon';

export const getPinStyle = ({
  value,
  color,
  textColor,
}: {
  value?: number;
  color: string;
  textColor?: string;
}): Style => {
  const pinIcon: PinIcon = 'pin';
  const pinSize = getPinSize(pinIcon);
  return new Style({
    image: new Icon({
      displacement: [ZERO, pinSize.height],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      img: getCanvasIcon({
        color,
        value,
        textColor,
        pinIcon,
      }),
    }),
  });
};
